<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import UserProfile from "@/router/views/users/user-profile"

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import UserUtils from '@/helpers/users';
import HelperUtils from '@/helpers/helper';
import Storage from "@/helpers/storage"

// Services
import GeneratorService from "@/services/GeneratorService";
import UsersDataService from "@/services/UsersDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

// Lib
import isEmpty from "is-empty";

export default {
  name: "actions-generator",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Generator Actions Controller",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...UserUtils,
    ...DateUtils,
    ...HelperUtils,

    handlePageMatchesChange(value) {
      this.matches.page = value;
      if (this.answersMatchesSearch === 'filters')
        this.loadMatchesList();
      else if (this.answersMatchesSearch === 'search')
        this.processMatchesSearch(false);
    },

    handlePageIceBreakersChange(value) {
      this.iceBreakers.page = value;
      if (this.answersIceBreakersSearch === 'filters')
        this.loadIceBreakersList();
      else if (this.answersIceBreakersSearch === 'search')
        this.processIceBreakersSearch(false);
    },

    handlePageChatRoomsChange(value) {
      this.chatRooms.page = value;
      if (this.answersChatRoomsSearch === 'filters')
        this.loadChatRoomsList();
      else if (this.answersChatRoomsSearch === 'search')
        this.processChatRoomsSearch(false);
    },

    handleDisplayIceBreakersChange() {
      this.loadIceBreakersList();
    },

    handleDisplayMatchesChange() {
      this.loadMatchesList();
    },

    handleDisplayChatRoomsChange() {
      this.loadChatRoomsList();
    },

    handleMatchesDateChange() {
      let now = new this.$moment();
      switch(this.filtersMatches.dates.selected) {
        case "always":
          this.filtersMatches.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersMatches.fromDate = now.format('YYYY-MM-DD');
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersMatches.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersMatches.toDate = this.filtersMatches.fromDate;
          break;
        case "week":
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          this.filtersMatches.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          this.filtersMatches.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          this.filtersMatches.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersMatches.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersMatches.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          this.filtersMatches.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersMatches.toDate = now.format('YYYY-MM-DD');
          this.filtersMatches.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersMatches.fromDate = null;
          this.filtersMatches.toDate = null;
          break;
      }
    },

    handleIceBreakersDateChange() {
      let now = new this.$moment();
      switch(this.filtersIceBreakers.dates.selected) {
        case "always":
          this.filtersIceBreakers.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersIceBreakers.fromDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersIceBreakers.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersIceBreakers.toDate = this.filtersIceBreakers.fromDate;
          break;
        case "week":
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersIceBreakers.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersIceBreakers.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersIceBreakers.toDate = now.format('YYYY-MM-DD');
          this.filtersIceBreakers.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersIceBreakers.fromDate = null;
          this.filtersIceBreakers.toDate = null;
          break;
      }
    },

    handleChatRoomsDateChange() {
      let now = new this.$moment();
      switch(this.filtersChatRooms.dates.selected) {
        case "always":
          this.filtersChatRooms.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filtersChatRooms.fromDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersChatRooms.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filtersChatRooms.toDate = this.filtersChatRooms.fromDate;
          break;
        case "week":
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersChatRooms.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersChatRooms.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersChatRooms.toDate = now.format('YYYY-MM-DD');
          this.filtersChatRooms.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersChatRooms.fromDate = null;
          this.filtersChatRooms.toDate = null;
          break;
      }
    },

    getMatchesRequestParams() {
      const params = {};

      params["page"] = this.matches.page - 1;
      params["size"] = this.matches.pageSizes.selected;

      if (this.filtersMatches.dates.selected === 'custom' && this.filtersMatches.dates.dateRange !== null) {
        this.filtersMatches.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersMatches.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersMatches.fromDate === null)
        this.handleMatchesDateChange();

      if (this.filtersMatches.toDate !== null)
        params['toDate'] = this.filtersMatches.toDate;

      if (this.filtersMatches.fromDate !== null)
        params['fromDate'] = this.filtersMatches.fromDate;

      params['gender'] = this.filtersMatches.genders.selected;
      params['status'] = this.filtersMatches.status.selected;
      params['countries'] = this.filtersMatches.countries.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getIceBreakersRequestParams() {
      const params = {};

      params["page"] = this.iceBreakers.page - 1;
      params["size"] = this.iceBreakers.pageSizes.selected;

      if (this.filtersIceBreakers.dates.selected === 'custom' && this.filtersIceBreakers.dates.dateRange !== null) {
        this.filtersIceBreakers.fromDate = this.$moment(this.filtersIceBreakers.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersIceBreakers.toDate = this.$moment(this.filtersIceBreakers.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersIceBreakers.fromDate === null)
        this.handleIceBreakersDateChange();

      if (this.filtersIceBreakers.toDate !== null)
        params['toDate'] = this.filtersIceBreakers.toDate;

      if (this.filtersIceBreakers.fromDate !== null)
        params['fromDate'] = this.filtersIceBreakers.fromDate;

      params['gender'] = this.filtersIceBreakers.genders.selected;
      params['status'] = this.filtersIceBreakers.status.selected;
      params['countries'] = this.filtersIceBreakers.countries.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getChatRoomsRequestParams() {
      const params = {};

      params["page"] = this.chatRooms.page - 1;
      params["size"] = this.chatRooms.pageSizes.selected;

      if (this.filtersChatRooms.dates.selected === 'custom' && this.filtersChatRooms.dates.dateRange !== null) {
        this.filtersChatRooms.fromDate = this.$moment(this.filtersChatRooms.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersChatRooms.toDate = this.$moment(this.filtersChatRooms.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filtersChatRooms.fromDate === null)
        this.handleChatRoomsDateChange();

      if (this.filtersChatRooms.toDate !== null)
        params['toDate'] = this.filtersChatRooms.toDate;

      if (this.filtersChatRooms.fromDate !== null)
        params['fromDate'] = this.filtersChatRooms.fromDate;

      params['gender'] = this.filtersChatRooms.genders.selected;
      params['status'] = this.filtersChatRooms.status.selected;
      params['countries'] = this.filtersChatRooms.countries.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    loadIceBreakersStats() {
      GeneratorService
          .getAnswersIceBreakersStats(this.getIceBreakersRequestParams())
          .then(response => {

            const {total, historyGraph} = response.data;
            this.stats.iceBreakers.success = total.success;
            this.stats.iceBreakers.waiting = total.waiting;
            this.stats.iceBreakers.errors = total.errors;
            this.stats.iceBreakers.declined = total.declined;
            this.stats.iceBreakers.unavailable = total.unavailable;
            this.stats.iceBreakers.maxlimit = total.maxlimit;

            this.$refs.answersHistoryIceBreakersChart.updateSeries([{
              name: "Waiting",
              type: 'bar',
              data: historyGraph.waiting
            },{
              name: "Declined",
              type: 'bar',
              data: historyGraph.declined
            }, {
              name: "Success",
              type: 'bar',
              data: historyGraph.success
            }, {
              name: "Unavailable",
              type: 'bar',
              data: historyGraph.unavailable
            }, {
              name: "Max Limit",
              type: 'bar',
              data: historyGraph.maxlimit
            }, {
              name: "Errors",
              type: 'bar',
              data: historyGraph.errors
            }]);
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadMatchesStats() {
      GeneratorService
          .getAnswersMatchesStats(this.getMatchesRequestParams())
          .then(response => {

            const {total, historyGraph} = response.data;
            this.stats.matches.success = total.success;
            this.stats.matches.waiting = total.waiting;
            this.stats.matches.errors = total.errors;
            this.stats.matches.declined = total.declined;
            this.stats.matches.unavailable = total.unavailable;
            this.stats.matches.maxlimit = total.maxlimit;

            this.$refs.answersHistoryMatchesChart.updateSeries([{
              name: "Waiting",
              type: 'bar',
              data: historyGraph.waiting
            },{
              name: "Declined",
              type: 'bar',
              data: historyGraph.declined
            }, {
              name: "Success",
              type: 'bar',
              data: historyGraph.success
            }, {
              name: "Unavailable",
              type: 'bar',
              data: historyGraph.unavailable
            }, {
              name: "Max Limit",
              type: 'bar',
              data: historyGraph.maxlimit
            }, {
              name: "Errors",
              type: 'bar',
              data: historyGraph.errors
            }]);
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadChatRoomsStats() {
      GeneratorService
          .getAnswersChatRoomsStats(this.getChatRoomsRequestParams())
          .then(response => {

            const {total, historyGraph} = response.data;
            this.stats.chatRooms.success = total.success;
            this.stats.chatRooms.waiting = total.waiting;
            this.stats.chatRooms.errors = total.errors;
            this.stats.chatRooms.declined = total.declined;
            this.stats.chatRooms.rescheduled = total.rescheduled;
            this.stats.chatRooms.maxlimit = total.maxlimit;

            this.$refs.answersHistoryChatRoomsChart.updateSeries([{
              name: "Waiting",
              type: 'bar',
              data: historyGraph.waiting
            },{
              name: "Declined",
              type: 'bar',
              data: historyGraph.declined
            }, {
              name: "Success",
              type: 'bar',
              data: historyGraph.success
            }, {
              name: "Rescheduled",
              type: 'bar',
              data: historyGraph.rescheduled
            }, {
              name: "Max Limit",
              type: 'bar',
              data: historyGraph.maxlimit
            }, {
              name: "Errors",
              type: 'bar',
              data: historyGraph.errors
            }]);
          })
          .catch(error => {
            window.console.error(error);
          });
    },

    loadIceBreakersList() {
      this.iceBreakers.isLoading = true;
      this.answersIceBreakersSearch = 'filters';
      GeneratorService
          .getAnswersIceBreakersList(this.getIceBreakersRequestParams())
          .then(response => {
            const { items, totalItems } = response.data;
            this.iceBreakers.scheduled = items;
            this.iceBreakers.count = totalItems;
            this.getMediaThumb("I");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.iceBreakers.isLoading = false;
          });
    },

    loadMatchesList() {
      this.matches.isLoading = true;
      this.answersMatchesSearch = 'filters';
      GeneratorService
          .getAnswersMatchesList(this.getMatchesRequestParams())
          .then(response => {
            const { items, totalItems } = response.data;
            this.matches.scheduled = items;
            this.matches.count = totalItems;
            this.getMediaThumb("M");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.matches.isLoading = false;
          });
    },

    loadChatRoomsList() {
      this.chatRooms.isLoading = true;
      this.answersChatRoomsSearch = 'filters';
      GeneratorService
          .getAnswersChatRoomsList(this.getChatRoomsRequestParams())
          .then(response => {
            const { items, totalItems } = response.data;
            this.chatRooms.scheduled = items;
            this.chatRooms.count = totalItems;
            this.getMediaThumb("C");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.chatRooms.isLoading = false;
          });
    },

    resetMatchesData() {
      this.matches.scheduled = [];
      this.stats.matches = {
        waiting: '-',
        success: '-',
        errors: '-',
        declined: '-',
        maxlimit: '-',
        unavailable: '-',
      };
    },

    resetIceBreakersData() {
      this.iceBreakers.scheduled = [];
      this.stats.iceBreakers = {
        waiting: '-',
        success: '-',
        errors: '-',
        declined: '-',
        maxlimit: '-',
        unavailable: '-',
      };
    },

    resetChatRoomsData() {
      this.chatRooms.scheduled = [];
      this.stats.chatRooms = {
        waiting: '-',
        success: '-',
        errors: '-',
        declined: '-',
        maxlimit: '-',
        rescheduled: '-',
      };
    },

    processMatchesFilters() {
      this.loadedMatches = true;
      this.resetMatchesData();
      this.loadMatchesList();
      this.loadMatchesStats();
    },

    processIceBreakersFilters() {
      this.loadedIceBreakers = true;
      this.resetIceBreakersData();
      this.loadIceBreakersList();
      this.loadIceBreakersStats();
    },

    processChatRoomsFilters() {
      this.loadedChatRooms = true;
      this.resetChatRoomsData();
      this.loadChatRoomsList();
      this.loadChatRoomsStats();
    },

    processSearch(resetPage) {
      let filters;
      switch (this.tabIndex) {
        case 0:
          filters = this.filtersChatRooms;
          break;

        case 1:
          filters = this.filtersMatches;
          break;

        case 2:
          filters = this.filtersIceBreakers;
          break;
      }

      if (isEmpty(filters.searchType)) {
        this.$toast.error(this.$t("answers.error_searchType"));
        return;
      }

      if (isEmpty(filters.searchData)) {
        this.$toast.error(this.$t("answers.error_searchData"));
        return;
      }

      switch (this.tabIndex) {
        case 0:
          this.answersChatRoomsSearch = 'search';
          if (resetPage) {
            this.chatRooms.page = 1;
          }
          this.processChatRoomsSearch();
          break;

        case 1:
          this.answersMatchesSearch = 'search';
          if (resetPage) {
            this.matches.page = 1;
          }
          this.processMatchesSearch();
          break;

        case 2:
          this.answersIceBreakersSearch = 'search';
          if (resetPage) {
            this.iceBreakers.page = 1;
          }
          this.processIceBreakersSearch();
          break;
      }
    },

    processMatchesSearch() {
      this.matches.isLoading = true;

      const params = {
        type: this.filtersMatches.searchType.selected,
        data: this.filtersMatches.searchData,
        page: this.matches.page - 1,
        size: this.matches.pageSizes.selected,
      };

      GeneratorService
          .searchAnswersMatches(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.matches.scheduled = items;
            this.matches.count = totalItems;
            this.getMediaThumb("M");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.matches.isLoading = false;
          });
    },

    processIceBreakersSearch() {
      this.iceBreakers.isLoading = true;
      const params = {
        type: this.filtersIceBreakers.searchType.selected,
        data: this.filtersIceBreakers.searchData,
        page: this.iceBreakers.page - 1,
        size: this.iceBreakers.pageSizes.selected,
      };

      GeneratorService
          .searchAnswersIceBreakers(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.iceBreakers.scheduled = items;
            this.iceBreakers.count = totalItems;
            this.getMediaThumb("I");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.iceBreakers.isLoading = false;
          });
    },

    processChatRoomsSearch() {
      this.chatRooms.isLoading = true;
      const params = {
        type: this.filtersChatRooms.searchType.selected,
        data: this.filtersChatRooms.searchData,
        page: this.iceBreakers.page - 1,
        size: this.iceBreakers.pageSizes.selected,
      };

      GeneratorService
          .searchAnswersIceBreakers(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.chatRooms.scheduled = items;
            this.chatRooms.count = totalItems;
            this.getMediaThumb("I");
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("answers.errorGeneratorNoResult"));
          })
          .finally(() => {
            this.chatRooms.isLoading = false;
      });
    },

    getMediaThumb(type) {
      let scheduled = type === "I" ? this.iceBreakers.scheduled : (type === "C" ? this.chatRooms.scheduled : this.matches.scheduled);
      let prefix = type === "I" ? "iceBreakers" : (type === "C" ? "chatRooms" : "matches");
      if (scheduled.length > 0)
        scheduled.forEach(row => {
          if (row.photo && row.photo.length > 0)
            Storage.getUserMedia(row.userId, row.photo, prefix + '-user-' + row.answerId);

          if (row.memberPhoto && row.memberPhoto.length > 0)
            Storage.getUserMedia(row.memberId, row.memberPhoto, prefix + '-user-' + row.answerId + "-liker");

        });
    },

    _isEmpty(val) {
      return isEmpty(val);
    },

    searchUser(userId) {
      switch (this.tabIndex) {
        case 0:
          this.filtersChatRooms.searchType.selected = 'userId';
          this.filtersChatRooms.searchData = userId;
          break;

        case 1:
          this.filtersMatches.searchType.selected = 'userId';
          this.filtersMatches.searchData = userId;
          break;

        case 2:
          this.filtersIceBreakers.searchType.selected = 'userId';
          this.filtersIceBreakers.searchData = userId;
          break;
      }

      this.processSearch(true);
    },

    showContextMenu(event, user) {
      this.$refs.answersContextMenu.showMenu(event, user)
    },

    processContextMenu(event) {
      const { item, option } = event;
      switch (option.value) {
        case "show":
          this.showUser(item.userId);
          break;

        case "search":
          this.searchUser(item.userId);
          break;
      }
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },

  mounted() {
    if (this.tabIndex === 0)
      this.processChatRoomsFilters();
    else if (this.tabIndex === 1)
      this.processMatchesFilters();
    else if (this.tabIndex === 2)
      this.processIceBreakersFilters();
  },

  watch: {
    tabIndex: function () {
      if (this.tabIndex === 0 && !this.loadedChatRooms) {
        this.processChatRoomsFilters();
      } else if (this.tabIndex === 1 && !this.loadedMatches) {
        this.processMatchesFilters();
      } else if (this.tabIndex === 2 && !this.loadedIceBreakers) {
        this.processIceBreakersFilters();
      }
    },
  },

  data() {
    return {
      tabIndex: 0,
      title: this.$t("menuitems.system.actions_generator"),

      loadedChatRooms: false,
      loadedMatches: false,
      loadedIceBreakers: false,

      answersMatchesSearch: 'filters',
      answersIceBreakersSearch: 'filters',
      answersChatRoomsSearch: 'filters',

      iceBreakers: {
        isLoading: false,
        scheduled: [],
        page: 1,
        count: 0,
        pageSizes: {
          options: ['20', '50', '100'],
          selected: '20'
        },
      },
      matches: {
        isLoading: false,
        scheduled: [],
        page: 1,
        count: 0,
        pageSizes: {
          options: ['20', '50', '100'],
          selected: '20'
        },
      },
      chatRooms: {
        isLoading: false,
        scheduled: [],
        page: 1,
        count: 0,
        pageSizes: {
          options: ['20', '50', '100'],
          selected: '20'
        },
      },

      optionsContext: [
        {
          name: this.$t("show_user"),
          value: 'show'
        },
        {
          name: this.$t("search_user"),
          value: 'search'
        },
      ],

      stats: {
        iceBreakers: {
          waiting: '-',
          success: '-',
          errors: '-',
          declined: '-',
          maxlimit: '-',
          unavailable: '-',
        },
        matches: {
          waiting: '-',
          success: '-',
          errors: '-',
          declined: '-',
          maxlimit: '-',
          unavailable: '-',
        },
        chatRooms: {
          waiting: '-',
          success: '-',
          errors: '-',
          declined: '-',
          maxlimit: '-',
          rescheduled: '-',
        },
      },

      historyGraph: {
        iceBreakers: {
          series: [],
          chartOptions: {
            chart: {
              stacked: true,
              type: 'bar',
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                borderRadius: 10,
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            colors: ["#f8bd25", "#666666", "#34c38f", "#556ee6", "#314dd7", "#f46a6a"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          },
        },
        matches: {
          series: [],
          chartOptions: {
            chart: {
              stacked: true,
              type: 'bar',
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                borderRadius: 10,
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            colors: ["#f8bd25", "#666666", "#34c38f", "#556ee6", "#314dd7", "#f46a6a"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          },
        },
        chatRooms: {
          series: [],
          chartOptions: {
            chart: {
              stacked: true,
              type: 'bar',
              toolbar: {
                show: true,
              },
              zoom: {
                enabled: true,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                endingShape: "rounded",
                borderRadius: 10,
                dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            colors: ["#f8bd25", "#666666", "#34c38f", "#556ee6", "#314dd7", "#f46a6a"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          },
        }
      },

      filtersMatches: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },

        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },

        status: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Status'},
            {value: 'S', text: 'Accepted'},
            {value: 'D', text: 'Declined'},
            {value: 'U', text: 'Unavailable'},
            {value: 'M', text: 'Max limit reached'},
            {value: 'E', text: 'Error'},
            {value: 'W', text: 'Waiting'},
          ]
        }
      },
      filtersIceBreakers: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },

        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },

        status: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Status'},
            {value: 'S', text: 'Accepted'},
            {value: 'D', text: 'Declined'},
            {value: 'U', text: 'Unavailable'},
            {value: 'M', text: 'Max limit reached'},
            {value: 'E', text: 'Error'},
            {value: 'W', text: 'Waiting'},
          ]
        }
      },
      filtersChatRooms: {
        searchType: {
          selected: 'userId',
          options: [
            {value:'userId', text:this.$t("userId")},
            {value:'email', text:this.$t("email")}
          ]
        },
        searchData: "",
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },

        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },

        status: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Status'},
            {value: 'S', text: 'Accepted'},
            {value: 'D', text: 'Declined'},
            {value: 'R', text: 'Rescheduled'},
            {value: 'M', text: 'Max limit reached'},
            {value: 'E', text: 'Error'},
            {value: 'W', text: 'Waiting'},
          ]
        }
      },

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <b-tabs content-class="" v-model="tabIndex">

        <!-- ChatRooms tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> ChatRooms Answers
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Filters -->
              <div class="card">

                <div class="card-body">
                  <!-- Search -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersSearchForm" @submit.stop.prevent>
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersSearchTypeFilter"
                          v-model="filtersChatRooms.searchType.selected"
                          class="form-select me-lg-1"
                          :options="filtersChatRooms.searchType.options">
                      </b-form-select>
                    </div>
                    <div class="col-sm-auto">
                      <b-form-input
                          id="answersSearchData"
                          class="me-lg-1"
                          v-model="filtersChatRooms.searchData"
                          placeholder="Search…">
                      </b-form-input>
                    </div>
                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processSearch(true)">{{ $t("searchBtn") }}</b-button>
                    </div>
                  </b-form>
                  <hr />
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersFiltersForm" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="answersDatesFilter"
                          @change="handleChatRoomsDateChange"
                          v-model="filtersChatRooms.dates.selected"
                          class="form-select me-lg-1"
                          :options="filtersChatRooms.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filtersChatRooms.dates.selected === 'custom'"
                          :lang="fr"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filtersChatRooms.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersCountriesFilter"
                          v-model="filtersChatRooms.countries.selected"
                          class="form-select me-lg-1"
                          :options="filtersChatRooms.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Genders -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersGenderFilter"
                          v-model="filtersChatRooms.genders.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersChatRooms.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Status -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersStatusFilter"
                          v-model="filtersChatRooms.status.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="st in filtersChatRooms.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processChatRoomsFilters">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="chatRooms.isLoading"
                    :loading="chatRooms.isLoading"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Stats Plain -->
              <div class="row card-body card-body" v-if="answersChatRoomsSearch === 'filters'">
                <!-- Success -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.success") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.success }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-success">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Waiting -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.waiting") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.waiting }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-warning">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.declined") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.declined }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-dark">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.maxLimit") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.maxlimit }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Rescheduled -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.rescheduled") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.rescheduled }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-primary">
                      <i class="bx bx-help-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Error -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.errors") }}</p>
                          <h4 class="mb-0">{{ stats.chatRooms.errors }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-danger">
                      <i class="bx bx-error font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row card-body" v-if="answersChatRoomsSearch === 'filters'">

                <!-- History -->
                <div class="col-12">
                  <div class="card">
                    <div class="card-body" id="cardChartGeneratorHistory">
                      <h5 class="card-title">History</h5>
                      <apexchart
                          ref="answersHistoryChatRoomsChart"
                          class="apex-charts"
                          type="bar"
                          dir="ltr"
                          height="300"
                          :series="historyGraph.chatRooms.series"
                          :options="historyGraph.chatRooms.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Top list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="chatRooms.pageSizes.selected" @change="handleDisplayChatRoomsChange">
                    <option v-for="size in chatRooms.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ chatRooms.count }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="chatRooms.page"
                        :total-rows="chatRooms.count"
                        :per-page="chatRooms.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageChatRoomsChange"
                        aria-controls="chatRooms-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row card-body" v-if="!chatRooms.isLoading && chatRooms.scheduled.length > 0">
                <div class="table-responsive card-body">
                  <table
                      id="chatRooms-list"
                      class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                  >
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('answers.scheduledAt') }}</th>
                      <th scope="col">{{ $t('answers.status') }}</th>
                      <th scope="col">{{ $t('answers.user') }}</th>
                      <th scope="col">{{ $t('answers.liker') }}</th>
                      <th scope="col">Diff.</th>
                      <th scope="col">Err.</th>
                      <th scope="col">{{ $t('action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in chatRooms.scheduled" :key="row.answerId" @contextmenu.prevent.stop="showContextMenu($event, row)">
                      <td>
                        <p class="text-muted font-size-12">{{ formatDateString(row.scheduledAt, 'DD MMM YYYY HH:mm') }}</p>
                      </td>
                      <td>
                  <span
                      class="badge"
                      :class="{
                        'bg-success text-light': `${row.status}` === 'S',
                        'bg-info text-light': `${row.status}` === 'M',
                        'bg-dark text-light': `${row.status}` === 'D',
                        'bg-danger text-light': `${row.status}` === 'E',
                        'bg-primary text-dark': `${row.status}` === 'R',
                        'bg-warning text-dark': `${row.status}` === 'W',
                      }"
                  >{{ row.status_descr }}</span>
                      </td>
                      <td>
                        <div class="media">
                          <div class="avatar-xs">
                            <img
                                :id="`chaRooms-user-${row.answerId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.sex === 1,
                            'text-danger': row.sex === 2,
                            'text-dark': row.sex === 0,
                          }"
                        >
                          {{ row.name || '-' }}
                        </span> {{ getAge(row.birth) }}</h5>
                            <small class="text-muted">#{{ row.userId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="media" v-show="row.memberId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`chaRooms-user-${row.answerId}-liker`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.memberSex === 1,
                            'text-danger': row.memberSex === 2,
                            'text-dark': row.memberSex === 0,
                          }"
                        >
                          {{ row.memberName || '-' }}
                        </span> {{ getAge(row.memberBirth) }}</h5>
                            <small class="text-muted">#{{ row.memberId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <b>{{ getDistanceFromLatLng(row.userLat, row.userLng, row.memberLat, row.memberLng) }}</b> km<br>
                        <b>{{ getAgeDiff(row.birth, row.memberBirth) }}</b> ans
                      </td>
                      <td>
                        <p v-show="!_isEmpty(row.error)">{{ row.error }}</p>
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(row.userId)"
                          >{{ $t("show_user") }}</b-dropdown-item>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="searchUser(row.userId)"
                          >{{ $t("search_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row card-body" v-if="!chatRooms.isLoading && chatRooms.scheduled.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Schedule were found for these filters or search. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="chatRooms.pageSizes.selected" @change="handleDisplayChatRoomsChange">
                    <option v-for="size in chatRooms.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="chatRooms.page"
                        :total-rows="chatRooms.count"
                        :per-page="chatRooms.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageChatRoomsChange"
                        aria-controls="chatRooms-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- Matches tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> Matches Answers
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Filters -->
              <div class="card">

                <div class="card-body">
                  <!-- Search -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersSearchForm" @submit.stop.prevent>
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersSearchTypeFilter"
                          v-model="filtersMatches.searchType.selected"
                          class="form-select me-lg-1"
                          :options="filtersMatches.searchType.options">
                      </b-form-select>
                    </div>
                    <div class="col-sm-auto">
                      <b-form-input
                          id="answersSearchData"
                          class="me-lg-1"
                          v-model="filtersMatches.searchData"
                          placeholder="Search…">
                      </b-form-input>
                    </div>
                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processSearch(true)">{{ $t("searchBtn") }}</b-button>
                    </div>
                  </b-form>
                  <hr />
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersFiltersForm" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="answersDatesFilter"
                          @change="handleMatchesDateChange"
                          v-model="filtersMatches.dates.selected"
                          class="form-select me-lg-1"
                          :options="filtersMatches.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filtersMatches.dates.selected === 'custom'"
                          :lang="fr"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filtersMatches.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersCountriesFilter"
                          v-model="filtersMatches.countries.selected"
                          class="form-select me-lg-1"
                          :options="filtersMatches.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Genders -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersGenderFilter"
                          v-model="filtersMatches.genders.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersMatches.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Status -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersStatusFilter"
                          v-model="filtersMatches.status.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="st in filtersMatches.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processMatchesFilters">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="matches.isLoading"
                    :loading="matches.isLoading"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Stats Plain -->
              <div class="row card-body" v-if="answersMatchesSearch === 'filters'">
                <!-- Success -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.success") }}</p>
                          <h4 class="mb-0">{{ stats.matches.success }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-success">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Waiting -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.waiting") }}</p>
                          <h4 class="mb-0">{{ stats.matches.waiting }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-warning">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.declined") }}</p>
                          <h4 class="mb-0">{{ stats.matches.declined }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-dark">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.maxLimit") }}</p>
                          <h4 class="mb-0">{{ stats.matches.maxlimit }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Unavailable -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.unavailable") }}</p>
                          <h4 class="mb-0">{{ stats.matches.unavailable }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-primary">
                      <i class="bx bx-help-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Error -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.errors") }}</p>
                          <h4 class="mb-0">{{ stats.matches.errors }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-danger">
                      <i class="bx bx-error font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row card-body" v-if="answersMatchesSearch === 'filters'">

                <!-- History -->
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">History</h5>
                      <apexchart
                          ref="answersHistoryMatchesChart"
                          class="apex-charts"
                          type="bar"
                          dir="ltr"
                          height="300"
                          :series="historyGraph.matches.series"
                          :options="historyGraph.matches.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Top list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="matches.pageSizes.selected" @change="handleDisplayMatchesChange">
                    <option v-for="size in matches.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ matches.count }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="matches.page"
                        :total-rows="matches.count"
                        :per-page="matches.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageMatchesChange"
                        aria-controls="matches-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row card-body" v-if="!matches.isLoading && matches.scheduled.length > 0">
                <div class="table-responsive card-body">
                  <table
                      id="matches-list"
                      class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                  >
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('answers.scheduledAt') }}</th>
                      <th scope="col">{{ $t('answers.status') }}</th>
                      <th scope="col">{{ $t('answers.user') }}</th>
                      <th scope="col">{{ $t('answers.liker') }}</th>
                      <th scope="col">Diff.</th>
                      <th scope="col">Err.</th>
                      <th scope="col">{{ $t('action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in matches.scheduled" :key="row.answerId" @contextmenu.prevent.stop="showContextMenu($event, row)">
                      <td>
                        <p class="text-muted font-size-12">{{ formatDateString(row.scheduledAt, 'DD MMM YYYY HH:mm') }}</p>
                      </td>
                      <td>
                  <span
                      class="badge"
                      :class="{
                        'bg-success text-light': `${row.status}` === 'S',
                        'bg-info text-light': `${row.status}` === 'M',
                        'bg-dark text-light': `${row.status}` === 'D',
                        'bg-danger text-light': `${row.status}` === 'E',
                        'bg-primary text-light': `${row.status}` === 'U',
                        'bg-warning text-dark': `${row.status}` === 'W',
                      }"
                  >{{ row.status_descr }}</span>
                      </td>
                      <td>
                        <div class="media">
                          <div class="avatar-xs">
                            <img
                                :id="`matches-user-${row.answerId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.sex === 1,
                            'text-danger': row.sex === 2,
                            'text-dark': row.sex === 0,
                          }"
                        >
                          {{ row.name || '-' }}
                        </span> {{ getAge(row.birth) }}</h5>
                            <small class="text-muted">#{{ row.userId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="media" v-show="row.memberId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`matches-user-${row.answerId}-liker`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.memberSex === 1,
                            'text-danger': row.memberSex === 2,
                            'text-dark': row.memberSex === 0,
                          }"
                        >
                          {{ row.memberName || '-' }}
                        </span> {{ getAge(row.memberBirth) }}</h5>
                            <small class="text-muted">#{{ row.memberId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <b>{{ getDistanceFromLatLng(row.userLat, row.userLng, row.memberLat, row.memberLng) }}</b> km<br>
                        <b>{{ getAgeDiff(row.birth, row.memberBirth) }}</b> ans
                      </td>
                      <td>
                        <p v-show="!_isEmpty(row.error)">{{ row.error }}</p>
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(row.userId)"
                          >{{ $t("show_user") }}</b-dropdown-item>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="searchUser(row.userId)"
                          >{{ $t("search_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row card-body" v-if="!matches.isLoading && matches.scheduled.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Matches Schedule were found for these filters or search. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="matches.pageSizes.selected" @change="handleDisplayMatchesChange">
                    <option v-for="size in matches.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="matches.page"
                        :total-rows="matches.count"
                        :per-page="matches.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageMatchesChange"
                        aria-controls="matches-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

        <!-- IceBreakers tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> IceBreakers Answers
          </template>
          <div class="card">
            <div class="card-body">

              <!-- Filters -->
              <div class="card">

                <div class="card-body">
                  <!-- Search -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersSearchForm" @submit.stop.prevent>
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersSearchTypeFilter"
                          v-model="filtersIceBreakers.searchType.selected"
                          class="form-select me-lg-1"
                          :options="filtersIceBreakers.searchType.options">
                      </b-form-select>
                    </div>
                    <div class="col-sm-auto">
                      <b-form-input
                          id="answersSearchData"
                          class="me-lg-1"
                          v-model="filtersIceBreakers.searchData"
                          placeholder="Search…">
                      </b-form-input>
                    </div>
                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processSearch(true)">{{ $t("searchBtn") }}</b-button>
                    </div>
                  </b-form>
                  <hr />
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" id="answersFiltersForm" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="answersDatesFilter"
                          @change="handleIceBreakersDateChange"
                          v-model="filtersIceBreakers.dates.selected"
                          class="form-select me-lg-1"
                          :options="filtersIceBreakers.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filtersIceBreakers.dates.selected === 'custom'"
                          :lang="fr"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filtersIceBreakers.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersCountriesFilter"
                          v-model="filtersIceBreakers.countries.selected"
                          class="form-select me-lg-1"
                          :options="filtersIceBreakers.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Genders -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersGenderFilter"
                          v-model="filtersIceBreakers.genders.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersIceBreakers.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Status -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="answersStatusFilter"
                          v-model="filtersIceBreakers.status.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="st in filtersIceBreakers.status.options" :key="st.value" :value="st.value">{{ st.text }}</option>
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processIceBreakersFilters">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="iceBreakers.isLoading"
                    :loading="iceBreakers.isLoading"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>

              <!-- Stats Plain -->
              <div class="row card-body card-body" v-if="answersIceBreakersSearch === 'filters'">
                <!-- Success -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.success") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.success }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-success">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Waiting -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.waiting") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.waiting }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-warning">
                      <i class="bx bx-check font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.declined") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.declined }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-dark">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Declined -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-dark fw-medium mb-2">{{ $t("answers.maxLimit") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.maxlimit }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-info">
                      <i class="bx bx-info-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Unavailable -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.unavailable") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.unavailable }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-primary">
                      <i class="bx bx-help-circle font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Error -->
                <div class="col-lg-2">
                  <div class="card mini-stats-wid">
                    <div class="card-body">
                      <div class="media">
                        <div class="media-body">
                          <p class="text-muted fw-medium mb-2">{{ $t("answers.errors") }}</p>
                          <h4 class="mb-0">{{ stats.iceBreakers.errors }}</h4>
                        </div>

                        <div class="avatar-sm align-self-center mini-stat-icon rounded-circle ">
                    <span class="avatar-title bg-danger">
                      <i class="bx bx-error font-size-24"></i>
                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row card-body" v-if="answersIceBreakersSearch === 'filters'">

                <!-- History -->
                <div class="col-12">
                  <div class="card">
                    <div class="card-body" id="cardChartGeneratorHistory">
                      <h5 class="card-title">History</h5>
                      <apexchart
                          ref="answersHistoryIceBreakersChart"
                          class="apex-charts"
                          type="bar"
                          dir="ltr"
                          height="300"
                          :series="historyGraph.iceBreakers.series"
                          :options="historyGraph.iceBreakers.chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                </div>

              </div>

              <!-- Top list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="iceBreakers.pageSizes.selected" @change="handleDisplayIceBreakersChange">
                    <option v-for="size in iceBreakers.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>

                  {{ iceBreakers.count }} {{ $t('resultsCount') }}
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="iceBreakers.page"
                        :total-rows="iceBreakers.count"
                        :per-page="iceBreakers.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageIceBreakersChange"
                        aria-controls="iceBreakers-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

              <!-- Result list -->
              <div class="row card-body" v-if="!iceBreakers.isLoading && iceBreakers.scheduled.length > 0">
                <div class="table-responsive card-body">
                  <table
                      id="iceBreakers-list"
                      class="table project-list-table table-nowrap table-centered table-borderless align-middle"
                  >
                    <thead>
                    <tr>
                      <th scope="col">{{ $t('answers.scheduledAt') }}</th>
                      <th scope="col">{{ $t('answers.status') }}</th>
                      <th scope="col">{{ $t('answers.user') }}</th>
                      <th scope="col">{{ $t('answers.liker') }}</th>
                      <th scope="col">Diff.</th>
                      <th scope="col">Err.</th>
                      <th scope="col">{{ $t('action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in iceBreakers.scheduled" :key="row.answerId" @contextmenu.prevent.stop="showContextMenu($event, row)">
                      <td>
                        <p class="text-muted font-size-12">{{ formatDateString(row.scheduledAt, 'DD MMM YYYY HH:mm') }}</p>
                      </td>
                      <td>
                  <span
                      class="badge"
                      :class="{
                        'bg-success text-light': `${row.status}` === 'S',
                        'bg-info text-light': `${row.status}` === 'M',
                        'bg-dark text-light': `${row.status}` === 'D',
                        'bg-danger text-light': `${row.status}` === 'E',
                        'bg-primary text-dark': `${row.status}` === 'U',
                        'bg-warning text-dark': `${row.status}` === 'W',
                      }"
                  >{{ row.status_descr }}</span>
                      </td>
                      <td>
                        <div class="media">
                          <div class="avatar-xs">
                            <img
                                :id="`iceBreakers-user-${row.answerId}`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.sex === 1,
                            'text-danger': row.sex === 2,
                            'text-dark': row.sex === 0,
                          }"
                        >
                          {{ row.name || '-' }}
                        </span> {{ getAge(row.birth) }}</h5>
                            <small class="text-muted">#{{ row.userId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="media" v-show="row.memberId !== null ">
                          <div class="avatar-xs">
                            <img
                                :id="`iceBreakers-user-${row.answerId}-liker`"
                                :src="require('@/assets/images/users/default-user.png')"
                                class="d-flex rounded-circle avatar-xs" />
                          </div>
                          <div class="media-body ms-1">
                            <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': row.memberSex === 1,
                            'text-danger': row.memberSex === 2,
                            'text-dark': row.memberSex === 0,
                          }"
                        >
                          {{ row.memberName || '-' }}
                        </span> {{ getAge(row.memberBirth) }}</h5>
                            <small class="text-muted">#{{ row.memberId }}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <b>{{ getDistanceFromLatLng(row.userLat, row.userLng, row.memberLat, row.memberLng) }}</b> km<br>
                        <b>{{ getAgeDiff(row.birth, row.memberBirth) }}</b> ans
                      </td>
                      <td>
                        <p v-show="!_isEmpty(row.error)">{{ row.error }}</p>
                      </td>
                      <td>
                        <b-dropdown
                            class="card-drop"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                            toggle-class="p-0"
                        >
                          <template v-slot:button-content>
                            <i class="mdi mdi-dots-horizontal font-size-18"></i>
                          </template>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="showUser(row.userId)"
                          >{{ $t("show_user") }}</b-dropdown-item>
                          <b-dropdown-item
                              href="javascript: void(0);"
                              @click="searchUser(row.userId)"
                          >{{ $t("search_user") }}</b-dropdown-item>
                        </b-dropdown>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Result Empty -->
              <div class="row card-body" v-if="!iceBreakers.isLoading && iceBreakers.scheduled.length === 0">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No Schedule were found for these filters or search. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- bottom list tools -->
              <div class="row card-body mb-3">
                <!-- Display settings -->
                <div class="col-lg-auto col-12">
                  <b-select class="form-select d-inline w-auto m-1" v-model="iceBreakers.pageSizes.selected" @change="handleDisplayIceBreakersChange">
                    <option v-for="size in iceBreakers.pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                  </b-select>
                </div>
                <!-- Pagination -->
                <div class="col-lg-auto col-12">
                  <div class="m-1 pagination-rounded">
                    <b-pagination
                        v-model="iceBreakers.page"
                        :total-rows="iceBreakers.count"
                        :per-page="iceBreakers.pageSizes.selected"
                        first-number
                        last-number
                        @change="handlePageIceBreakersChange"
                        aria-controls="iceBreakers-list"
                    ></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-tab>

      </b-tabs>

    </div>
    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <vue-simple-context-menu
        element-id="answersContextMenu"
        :options="optionsContext"
        ref="answersContextMenu"
        @option-clicked="processContextMenu"
    />

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}
</style>
